import React from "react";
import { getPasswordRequirements } from "../utils/auth";

interface PasswordRequirementsWarningProps {
  password: string;
  showRequirements: boolean;
}

export const PasswordRequirementsWarning: React.FC<
  PasswordRequirementsWarningProps
> = ({ password, showRequirements }) => {
  if (!showRequirements) return null;

  const requirements = getPasswordRequirements(password);
  const metCount = requirements.filter((req) => req.met).length;
  const totalCount = requirements.length;

  return (
    <div className="mt-2 p-3 bg-gray-50 rounded-md">
      <div className="text-sm text-gray-600 mb-2">
        Password requirements ({metCount}/{totalCount} met):
      </div>
      <ul className="space-y-1">
        {requirements.map((req, index) => (
          <li
            key={index}
            className={`text-xs flex items-center ${
              req.met ? "text-green-600" : "text-red-600"
            }`}
          >
            <span
              className={`mr-2 ${req.met ? "text-green-500" : "text-red-500"}`}
            >
              {req.met ? "✓" : "✗"}
            </span>
            {req.text}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PasswordRequirementsWarning;
